import { withParticle } from "@cwb/core";
import type { ParticlePair } from "@cwb/core";
import { getLocale } from "./runtime";

/** Game-specific Korean inflection stays outside the language registry/runtime. */
export function withLocaleParticle(
  name: string,
  pair: ParticlePair,
  tag = getLocale(),
): string {
  return tag.split("-")[0] === "ko" ? withParticle(name, pair) : name;
}
